//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './StudyNotesClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetStudyNotesConfigStudyNotesQueryParameters = {
  studyId: number;
};

export type UploadConfigFileStudyNotesMutationParameters = {
  file?: Types.FileParameter | null | undefined ; 
};

export type GetStudyNotesStudyNotesQueryParameters = {
  studyId: number;
};

export type UploadResultFileStudyNotesMutationParameters = {
  file?: Types.FileParameter | null | undefined ; 
};

    
export function getStudyNotesConfigUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/config";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getStudyNotesConfigDefaultOptions: UseQueryOptions<Types.StudyNoteConfigDto, unknown, Types.StudyNoteConfigDto> = {
  queryFn: __getStudyNotesConfig,
};
export function getGetStudyNotesConfigDefaultOptions(): UseQueryOptions<Types.StudyNoteConfigDto, unknown, Types.StudyNoteConfigDto> {
  return getStudyNotesConfigDefaultOptions;
};
export function setGetStudyNotesConfigDefaultOptions(options: UseQueryOptions<Types.StudyNoteConfigDto, unknown, Types.StudyNoteConfigDto>) {
  getStudyNotesConfigDefaultOptions = options;
}

export function getStudyNotesConfigQueryKey(studyId: number): QueryKey;
export function getStudyNotesConfigQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId,  } = params[0] as GetStudyNotesConfigStudyNotesQueryParameters;

    return trimArrayEnd([
        'StudyNotesClient',
        'getStudyNotesConfig',
        studyId as any,
      ]);
  } else {
    return trimArrayEnd([
        'StudyNotesClient',
        'getStudyNotesConfig',
        ...params
      ]);
  }
}
function __getStudyNotesConfig(context: QueryFunctionContext) {
  return Client.getStudyNotesConfig(
      context.queryKey[2] as number    );
}

export function useGetStudyNotesConfigQuery<TSelectData = Types.StudyNoteConfigDto, TError = unknown>(dto: GetStudyNotesConfigStudyNotesQueryParameters, options?: UseQueryOptions<Types.StudyNoteConfigDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetStudyNotesConfigQuery<TSelectData = Types.StudyNoteConfigDto, TError = unknown>(studyId: number, options?: UseQueryOptions<Types.StudyNoteConfigDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetStudyNotesConfigQuery<TSelectData = Types.StudyNoteConfigDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.StudyNoteConfigDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId,  } = params[0] as GetStudyNotesConfigStudyNotesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.StudyNoteConfigDto, TError, TSelectData>({
    queryFn: __getStudyNotesConfig,
    queryKey: getStudyNotesConfigQueryKey(studyId),
    ...getStudyNotesConfigDefaultOptions as unknown as UseQueryOptions<Types.StudyNoteConfigDto, TError, TSelectData>,
    ...options,
  });
}

export function setGetStudyNotesConfigData(queryClient: QueryClient, updater: (data: Types.StudyNoteConfigDto | undefined) => Types.StudyNoteConfigDto, studyId: number) {
  queryClient.setQueryData(getStudyNotesConfigQueryKey(studyId),
    updater
  );
}

export function setGetStudyNotesConfigDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.StudyNoteConfigDto | undefined) => Types.StudyNoteConfigDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function createStudyNotesConfigUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/config";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createStudyNotesConfigMutationKey(studyId: number): MutationKey {
  return trimArrayEnd([
      'StudyNotesClient',
      'createStudyNotesConfig',
      studyId as any,
    ]);
}

export function useCreateStudyNotesConfigMutation<TContext>(studyId: number, options?: Omit<UseMutationOptions<Types.StudyNoteConfigDto, unknown, Types.StudyNoteConfigCreationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.StudyNoteConfigDto, unknown, Types.StudyNoteConfigCreationDto, TContext> {
  const key = createStudyNotesConfigMutationKey(studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.StudyNoteConfigCreationDto) => Client.createStudyNotesConfig(studyId, dto), {...options, mutationKey: key});
}
  
    
export function patchStudyNotesConfigUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/config";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchStudyNotesConfigMutationKey(studyId: number): MutationKey {
  return trimArrayEnd([
      'StudyNotesClient',
      'patchStudyNotesConfig',
      studyId as any,
    ]);
}

export function usePatchStudyNotesConfigMutation<TContext>(studyId: number, options?: Omit<UseMutationOptions<Types.StudyNoteConfigDto, unknown, Types.StudyNoteConfigPatchingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.StudyNoteConfigDto, unknown, Types.StudyNoteConfigPatchingDto, TContext> {
  const key = patchStudyNotesConfigMutationKey(studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.StudyNoteConfigPatchingDto) => Client.patchStudyNotesConfig(studyId, dto), {...options, mutationKey: key});
}
  
    
export function removeStudyNotesConfigUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/config";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeStudyNotesConfigMutationKey(studyId: number): MutationKey {
  return trimArrayEnd([
      'StudyNotesClient',
      'removeStudyNotesConfig',
      studyId as any,
    ]);
}

export function useRemoveStudyNotesConfigMutation<TContext>(studyId: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeStudyNotesConfigMutationKey(studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.removeStudyNotesConfig(studyId), {...options, mutationKey: key});
}
  
    
export function uploadConfigFileUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/config/files/upload";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function uploadConfigFileMutationKey(studyId: number): MutationKey {
  return trimArrayEnd([
      'StudyNotesClient',
      'uploadConfigFile',
      studyId as any,
    ]);
}

export function useUploadConfigFileMutation<TContext>(studyId: number, options?: Omit<UseMutationOptions<string, unknown, UploadConfigFileStudyNotesMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, UploadConfigFileStudyNotesMutationParameters, TContext> {
  const key = uploadConfigFileMutationKey(studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((uploadConfigFileStudyNotesMutationParameters: UploadConfigFileStudyNotesMutationParameters) => Client.uploadConfigFile(studyId, uploadConfigFileStudyNotesMutationParameters.file), {...options, mutationKey: key});
}
  
    
export function getStudyNotesUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/results";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getStudyNotesDefaultOptions: UseQueryOptions<Types.StudyNoteResultDto[], unknown, Types.StudyNoteResultDto[]> = {
  queryFn: __getStudyNotes,
};
export function getGetStudyNotesDefaultOptions(): UseQueryOptions<Types.StudyNoteResultDto[], unknown, Types.StudyNoteResultDto[]> {
  return getStudyNotesDefaultOptions;
};
export function setGetStudyNotesDefaultOptions(options: UseQueryOptions<Types.StudyNoteResultDto[], unknown, Types.StudyNoteResultDto[]>) {
  getStudyNotesDefaultOptions = options;
}

export function getStudyNotesQueryKey(studyId: number): QueryKey;
export function getStudyNotesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId,  } = params[0] as GetStudyNotesStudyNotesQueryParameters;

    return trimArrayEnd([
        'StudyNotesClient',
        'getStudyNotes',
        studyId as any,
      ]);
  } else {
    return trimArrayEnd([
        'StudyNotesClient',
        'getStudyNotes',
        ...params
      ]);
  }
}
function __getStudyNotes(context: QueryFunctionContext) {
  return Client.getStudyNotes(
      context.queryKey[2] as number    );
}

export function useGetStudyNotesQuery<TSelectData = Types.StudyNoteResultDto[], TError = unknown>(dto: GetStudyNotesStudyNotesQueryParameters, options?: UseQueryOptions<Types.StudyNoteResultDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetStudyNotesQuery<TSelectData = Types.StudyNoteResultDto[], TError = unknown>(studyId: number, options?: UseQueryOptions<Types.StudyNoteResultDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetStudyNotesQuery<TSelectData = Types.StudyNoteResultDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.StudyNoteResultDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId,  } = params[0] as GetStudyNotesStudyNotesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.StudyNoteResultDto[], TError, TSelectData>({
    queryFn: __getStudyNotes,
    queryKey: getStudyNotesQueryKey(studyId),
    ...getStudyNotesDefaultOptions as unknown as UseQueryOptions<Types.StudyNoteResultDto[], TError, TSelectData>,
    ...options,
  });
}

export function setGetStudyNotesData(queryClient: QueryClient, updater: (data: Types.StudyNoteResultDto[] | undefined) => Types.StudyNoteResultDto[], studyId: number) {
  queryClient.setQueryData(getStudyNotesQueryKey(studyId),
    updater
  );
}

export function setGetStudyNotesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.StudyNoteResultDto[] | undefined) => Types.StudyNoteResultDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function processNewStudyNoteUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/results/new";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function processNewStudyNoteMutationKey(studyId: number): MutationKey {
  return trimArrayEnd([
      'StudyNotesClient',
      'processNewStudyNote',
      studyId as any,
    ]);
}

export function useProcessNewStudyNoteMutation<TContext>(studyId: number, options?: Omit<UseMutationOptions<void, unknown, Types.StudyNoteProcessingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.StudyNoteProcessingDto, TContext> {
  const key = processNewStudyNoteMutationKey(studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.StudyNoteProcessingDto) => Client.processNewStudyNote(studyId, dto), {...options, mutationKey: key});
}
  
    
export function processNewStudyNoteVersionUrl(studyId: number, resultId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/results/{resultId}/newVersion";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
if (resultId === undefined || resultId === null)
  throw new Error("The parameter 'resultId' must be defined.");
url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function processNewStudyNoteVersionMutationKey(studyId: number, resultId: number): MutationKey {
  return trimArrayEnd([
      'StudyNotesClient',
      'processNewStudyNoteVersion',
      studyId as any,
      resultId as any,
    ]);
}

export function useProcessNewStudyNoteVersionMutation<TContext>(studyId: number, resultId: number, options?: Omit<UseMutationOptions<void, unknown, Types.StudyNoteProcessingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.StudyNoteProcessingDto, TContext> {
  const key = processNewStudyNoteVersionMutationKey(studyId, resultId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.StudyNoteProcessingDto) => Client.processNewStudyNoteVersion(studyId, resultId, dto), {...options, mutationKey: key});
}
  
    
export function removeStudyNoteUrl(studyId: number, resultId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/results/{resultId}";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
if (resultId === undefined || resultId === null)
  throw new Error("The parameter 'resultId' must be defined.");
url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeStudyNoteMutationKey(studyId: number, resultId: number): MutationKey {
  return trimArrayEnd([
      'StudyNotesClient',
      'removeStudyNote',
      studyId as any,
      resultId as any,
    ]);
}

export function useRemoveStudyNoteMutation<TContext>(studyId: number, resultId: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeStudyNoteMutationKey(studyId, resultId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.removeStudyNote(studyId, resultId), {...options, mutationKey: key});
}
  
    
export function uploadResultFileUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/results/files/upload";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function uploadResultFileMutationKey(studyId: number): MutationKey {
  return trimArrayEnd([
      'StudyNotesClient',
      'uploadResultFile',
      studyId as any,
    ]);
}

export function useUploadResultFileMutation<TContext>(studyId: number, options?: Omit<UseMutationOptions<string, unknown, UploadResultFileStudyNotesMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, UploadResultFileStudyNotesMutationParameters, TContext> {
  const key = uploadResultFileMutationKey(studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((uploadResultFileStudyNotesMutationParameters: UploadResultFileStudyNotesMutationParameters) => Client.uploadResultFile(studyId, uploadResultFileStudyNotesMutationParameters.file), {...options, mutationKey: key});
}